import makeDoFetchJiraIssues from 'ducks/integrations/jiraShared/operations/makeDoFetchJiraIssues'

export default makeDoFetchJiraIssues(
  'integrations/jira_cloud',
  siteId => `proxy/atlassian/ex/jira/${siteId}/rest/api/3/search`
)
